<template></template>
<script>
    export default {
        data() {
            return {
                pageTitle: null,
                originalTitle: document.title
            }
        },
        mounted() {
            this.setTitle();
        },
        methods: {
            setTitle() {
                if (typeof this.$route.name === 'string') {

                    if (this.originalTitle.indexOf('|') !== -1) {
                        this.originalTitle = this.originalTitle.split('|')[0];
                    }

                    this.pageTitle = this.$route.name;
                    document.title = this.originalTitle + ' | ' + this.pageTitle;

                    let titleText = this.pageTitle;

                    if (typeof this.$route.meta !== 'undefined' && typeof this.$route.meta.menuTitle !== 'undefined') {
                        titleText = this.$route.meta.menuTitle;
                    }

                    let title = {
                        'type': 'text',
                        'text': titleText,
                        'color': 'white',
                        'slug': 'page-menu-title',
                        'order': 1
                    };

                    this.$store.dispatch('application/addTopBarItem', {'item': title, 'position': 'left'});

                } else {
                    this.pageTitle = null;
                    console.error('No title set for path [%s]', this.$route.path);
                }
            },
        },
        name: 'Title-Updater',
        watch: {
            '$route'() {
                this.setTitle();
            }
        },
    }
</script>
